var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFurniture2(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "45px",
    height: "45px",
    viewBox: "0 0 45 45",
    enableBackground: "new 0 0 45 45",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 26.5,
    y: 19.5,
    fill: "none",
    width: 7.9,
    height: 7.4
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M37,16.5h-3v-1l3.5-7.3c0-0.1,0-0.3-0.1-0.4c-0.1-0.2-0.2-0.3-0.4-0.3c-1.5,0.1-2.8,1-3.4,2.3L31,14.5h-4 c-1.1,0.1-2.1,0.9-2.4,2H24c-0.3,0-0.5,0.2-0.5,0.5v5.5c0-0.8-0.7-1.5-1.5-1.5h-9.7c0.2-0.7,0.2-1.4,0.2-2.1L12,9.5 c-0.1-1.9-1.3-2-2.5-2s-2,0.5-2,2.5L8,19.5c0,1,0.1,1.9,0.5,2.8V23c0,0.8,0.7,1.5,1.5,1.5h2.1C12.1,24.7,12,24.9,12,25v0.5 c0.1,0.8,0.7,1.4,1.5,1.4h1v6H11c-0.3,0-0.5,0.2-0.5,0.5C9.6,33.7,9,34.6,9,35.5c0.1,1,0.8,1.7,1.8,1.8c1,0.1,1.9-0.5,2.1-1.5H19 c0.1,1.1,1,1.9,2.2,1.8c1.1-0.1,1.9-1,1.8-2.2c0-0.9-0.6-1.7-1.5-2c0-0.3-0.2-0.5-0.5-0.5h-3.5v-6h1c0.8,0,1.5-0.7,1.5-1.5V25 c0-0.2-0.1-0.3-0.1-0.5H22c0.8,0,1.5-0.7,1.5-1.5V37c0,0.3,0.2,0.5,0.5,0.5h2c0.3,0,0.5-0.2,0.5-0.5v-7h7.9v7 c0,0.3,0.2,0.5,0.5,0.5h2c0.3,0,0.5-0.2,0.5-0.5V17C37.5,16.8,37.2,16.5,37,16.5z M19.8,34c-0.3,0.3-0.6,0.6-0.7,1H13 c-0.1-0.4-0.3-0.7-0.6-1H19.8z M19,25.5c0,0.3-0.2,0.5-0.5,0.5h-5c-0.3,0-0.5-0.2-0.5-0.5V25c0-0.3,0.2-0.5,0.5-0.5h5 c0.3,0,0.5,0.2,0.5,0.5V25.5z M34.5,29h-8v-1h8V29z M26.5,27v-7.4h7.9V27H26.5z M36.5,36.5h-1V19c0-0.3-0.2-0.5-0.5-0.5H26 c-0.3,0-0.5,0.2-0.5,0.5v17.4h-1V17.5h11.9V36.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C9C9C9",
    d: "M13,35H19c0.1-0.4,0.4-0.7,0.7-1h-7.4C12.6,34.2,12.8,34.6,13,35z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C9C9C9",
    d: "M18.5,24.5h-5c-0.3,0-0.5,0.2-0.5,0.5v0.5c0,0.3,0.2,0.5,0.5,0.5h5c0.3,0,0.5-0.2,0.5-0.5V25 C19,24.8,18.8,24.5,18.5,24.5z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26.5,
    y: 28,
    fill: "#C9C9C9",
    width: 8,
    height: 1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C9C9C9",
    d: "M24.5,36.5h1V19c0-0.3,0.2-0.5,0.5-0.5H35c0.3,0,0.5,0.2,0.5,0.5v17.4h1V17.5H24.5V36.5z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFurniture2);
export default __webpack_public_path__ + "static/media/furniture_2.73ab51c7acf90dac6af903be02f4eb69.svg";
export { ForwardRef as ReactComponent };